'use client'

import React from "react";
import Link from "next/link";

function OfferStylistCard() {
  return (
    <div className="block mx-auto max-w-screen-2xl ">
      <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
        <div className="lg:p-16 p-6 bg-pink-600 shadow-sm border rounded-lg">
          <div className="w-full bg-white shadow-sm lg:px-10 lg:py-5 p-6 rounded-lg ">
            <div className="flex justify-between items-center">
              <div className="lg:w-3/5">
                {/* <span className="text-base lg:text-lg">
                  Organic Products and Food
                </span> */}
                <h2 className="text-lg lg:text-2xl font-bold mb-1">
                 Door to Door Beauty{" "}
                  <span className="text-pink-600">Offers</span>
                </h2>
                <p className="text-sm leading-6">
                Unlock exclusive offers and pamper yourself with Door to Door Beauty. Enjoy special promotions, discounts, and complimentary gifts for first-time users. Whether it's a relaxing massage, a stylish manicure, or a stunning hair makeover, our irresistible offers make luxury beauty services more accessible than ever. Treat yourself to a truly indulgent experience with our enticing deals.
                </p>
                <Link
                  className="lg:w-1/4 hover:no-underline text-md font-medium inline-block mt-5 px-8 py-3 bg-pink-600 text-center text-white rounded-full hover:text-white hover:bg-emerald-600"
                  to="/#"
                >
                  Book Now
                </Link>
              </div>
              <div className="w-1/5 flex-grow hidden lg:lexx md:flex md:justify-items-center lg:justify-end">
                <span
                  style={{
                    boxSizing: " border-box",
                    display: "inline-block",
                    overflow: "hidden",
                    width: "initial",
                    height: "initial",
                    background: "none",
                    opacity: " 1",
                    border: "0px",
                    margin: "0px",
                    padding: " 0px",
                    position: "relative",
                    maxWidth: "100%",
                  }}
                >
                  <img  
  loading="lazy"  // Lazy loading added here
src="/assets/img/delivery-boy.png" alt="offers card" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OfferStylistCard;